import Standard from './Standard.vue'
import Full from './Full.vue'
import VideoFull from './VideoFull.vue'
import BlackBox from './BlackBox.vue'
import Summary from './Summary.vue'
import Question from './Question.vue'
import IdealTextQuestion from './IdealTextQuestion.vue'
import OpenResponseQuestion from './OpenResponseQuestion.vue'
import OpenResponseQuestionWithFeedback from './OpenResponseQuestionWithFeedback.vue'
import OpenResponseQuestionAI from './OpenResponseQuestionAI.vue'
import Stop from './Stop.vue'
import RandomEvent from './RandomEvent.vue'
import Grid from './Grid.vue'
import Consequence from './Consequence.vue'
import Multiplier from './Multiplier.vue'
import DragSort from './DragSort.vue'
import Input from './Input.vue'
import MetaAnalysis from './MetaAnalysis.vue'
import ClickReveal from './ClickReveal.vue'
import OpenResponseQuestionMultiAI from './OpenResponseQuestionMultiAI.vue'
import Menu from './Menu.vue'
import Carousel from './Carousel.vue'

export default {
  Standard,
  Full,
  VideoFull,
  BlackBox,
  Summary,
  Question,
  IdealTextQuestion,
  OpenResponseQuestion,
  OpenResponseQuestionWithFeedback,
  OpenResponseQuestionAI,
  Stop,
  RandomEvent,
  Grid,
  Consequence,
  Multiplier,
  DragSort,
  Input,
  MetaAnalysis,
  ClickReveal,
  OpenResponseQuestionMultiAI,
    Menu,
    Carousel
}
